import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { OrderService } from '@order/services/order.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import moment from 'moment';
import { FEATURES } from '@shared/constants/splitio-features';

@Component({
  selector: 'app-start-new-order-mobile',
  templateUrl: './start-new-order-mobile.component.html',
  styleUrls: ['./start-new-order-mobile.component.scss'],
})
export class StartNewOrderMobileComponent {
  addToOrderModalForm: FormGroup;
  nextDeliveryDate: string | Date;
  data: any;
  minDeliveryDate: Date | string;
  currentPickupDate: Date | String;
  deliveryDaysSub: Subscription;
  eligibleDeliveryDays: number[];
  poRegex = new RegExp('^[-0-9a-zA-Z ]{1,20}$');
  prontoDeliveryDays: number[];
  defaultPoFeatureFlag = FEATURES.split_dynamic_default_po.name;

  constructor(
    public navParams: NavParams,
    private orderService: OrderService,
    private fb: FormBuilder,
    private modalController: ModalController,
  ) {
    let formatMinDate = moment().startOf('day').format('YYYY-MM-DDTHH:mm');
    this.minDeliveryDate = formatMinDate;
    this.currentPickupDate = formatMinDate;

    this.data = navParams?.get('data');
    this.fb = fb;
    this.addToOrderModalForm = this.fb.group({
      selectedDeliveryDate: new FormControl(
        moment.utc(this.data?.nextDeliveryDate).format('YYYY-MM-DDTHH:mm'),
      ),
      poNumber: new FormControl(this.data?.defaultPoNumber || ''),
      saveDefaultPo: new FormControl(false),
    });

    this.deliveryDaysSub = this.orderService
      .selectedCustomerDeliveryDays()
      .pipe(take(1))
      .subscribe(selectedDays => {
        this.eligibleDeliveryDays = selectedDays;
      });

    this.orderService
      .selectedCustomerProntoDeliveryDays()
      .pipe(take(1))
      .subscribe(selectedDays => {
        this.prontoDeliveryDays = selectedDays;
      });
  }

  ionViewWillEnter(): void {}

  async closeModal() {
    const modData = {
      orderHeader: this.data.orderHeader,
      origOrderItems: this.data.origOrderItems,
      updateOrderItem: this.data.updateOrderItem,
    };
    this.orderService.cancelAddToOrderModal(modData);
    await this.modalController.dismiss();
  }

  async onSubmit(currentTab: number, addToOrderModalForm: FormGroup) {
    if (currentTab === 2) {
      return;
    }
    const selectedDeliveryDate = moment.utc(
      addToOrderModalForm?.get('selectedDeliveryDate').value,
      'YYYY-MM-DDTHH:mm:ss',
    );
    let poNumber = addToOrderModalForm.get('poNumber').value;
    const submittedModalData = {
      currentTab: currentTab,
      orderHeader: {
        ...this.data.orderHeader,
        purchaseOrderNumber: poNumber,
        requestedDeliveryDate: selectedDeliveryDate.isValid()
          ? selectedDeliveryDate.toISOString()
          : null,
        confirmedDeliveryDate: selectedDeliveryDate.isValid()
          ? selectedDeliveryDate.toISOString()
          : null,
      },
      origOrderItems: this.data.origOrderItems,
      updateOrderItem: this.data.updateOrderItem,
    };

    if (addToOrderModalForm?.get('saveDefaultPo')?.value) {
      await this.data.saveDefaultPoNumber(poNumber);
    }

    this.orderService.submitAddToOrderModal(submittedModalData);
  }

  isEligibleDay = (dateString: string) => {
    const today = moment().startOf('day').format('YYYY-MM-DD');
    if (today === dateString) {
      return false;
    }
    const date = new Date(dateString);
    const utcDay = date.getUTCDay();
    return this.eligibleDeliveryDays?.includes(utcDay);
  };

  prontoDayStyle = isoString => {
    if (this.prontoDeliveryDays === undefined) return undefined;
    if (moment().isSameOrBefore(isoString) && this.isEligibleDay(isoString)) {
      const date = new Date(isoString);
      const utcDay = date.getUTCDay();
      if (this.prontoDeliveryDays?.includes(utcDay)) {
        return {
          textColor: 'var(--ion-color-gray-80)',
          backgroundColor: '#F3BA1633',
        };
      } else {
        return {
          textColor: 'var(--ion-color-gray-80)',
          backgroundColor: 'var(--ion-color-primary-green-20)',
        };
      }
    }
    return undefined;
  };
}
